import './src/main.css'
import Charts from './src/main.vue'

export default function (Vue) {
  Vue.component(Charts.name, Charts)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/charts/index.js